module.exports = __webpack_public_path__ + "img/12.d1758516.jpg";